module.exports = __webpack_public_path__ + "static/media/about-moken-first-right@2x.3d8a0c28.jpg";